import Swiper from 'swiper/bundle';

if($(".corresponding-slider.swiper-container").length > 0) {
    const corresponding_swiper = new Swiper(".corresponding-slider.swiper-container", {
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next.corresponding-swiper-button",
            prevEl: ".swiper-button-prev.corresponding-swiper-button",
        },
    });
}